import "jimp";

export const Jimp = (typeof window !== "undefined"
  ? (window as any).Jimp
  : undefined) as unknown as typeof import("jimp");
export type JimpImage = Awaited<ReturnType<typeof Jimp.read>>;
export async function jimpImages(
  images: (string | JimpImage | HTMLCanvasElement)[]
): Promise<JimpImage[]> {
  return Promise.all(
    images.map((img) =>
      typeof img === "string"
        ? Jimp.read(img)
        : img instanceof HTMLCanvasElement
        ? Jimp.read(img.toDataURL())
        : Promise.resolve(img as JimpImage)
    )
  );
}
